import config from "./config";

export default map => {
  config({
    custom_map: map
  });
};
